import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';

// Consent text NHA publishes for ABHA creation, with the "I agree" box (NHA M1 CRT_ABHA_102).
@Component({
  selector: 'app-abha-consent',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule, TranslateModule],
  templateUrl: './abha-consent.component.html',
  styleUrl: './abha-consent.component.scss',
})
export class AbhaConsentComponent {
  @Input({ required: true }) control!: FormControl<boolean>;

  readonly consentPointKeys: readonly string[] = [
    'ABHA.CONSENT_POINT_1',
    'ABHA.CONSENT_POINT_2',
    'ABHA.CONSENT_POINT_3',
    'ABHA.CONSENT_POINT_4',
  ];

  get isMissing(): boolean {
    return this.control.touched && !this.control.value;
  }
}
